import { z } from 'zod';
import { IssueStatusFilterSchema } from '@/features/stacktrace/issues/-constants';
import { IssueSeverity } from '@/features/stacktrace/issues/-query/type';
import { IssueTableColumns } from './-table/type';
const issueSeverityValues = Object.values(IssueSeverity) as [(typeof IssueSeverity)[keyof typeof IssueSeverity], ...(typeof IssueSeverity)[keyof typeof IssueSeverity][]];

/**
 * テストスイート詳細 > 不具合タブ で利用する URL search 定義。
 *
 * 不具合一覧画面（`/issues`）のスキーマと同等の構成。
 * 当タブも一覧画面と同じく「未対応 / 対応中 / バックログ / 再現待ち / すべて」の
 * ステータスタブを表示するため `status` を URL search に含める。
 *
 * `productionId` は URL ではなくページコンポーネント側で `ReleaseTest.productionId`
 * を取得して固定値として注入するため、ここでは管理しない。
 */
export const TestSuiteIssueTableFilterSchema = z.object({
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(IssueTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc'),
  status: IssueStatusFilterSchema.default('ALL'),
  freeText: z.string().optional(),
  severity: z.enum(issueSeverityValues).optional(),
  productionProductId: z.string().optional()
});